import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { SHOW_BONUS_BAND, SESSION_MINUTES, BUILT_STORAGE_KEY } from '../config/builtSessions';
import './Built.css';
import './Opportunity.css';
import { BuiltQuiz } from './BuiltQuiz';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ME = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/2t98fqnu_untitled-0235.webp';
const IDS_URL = 'https://monatglobal.com/income-disclosure-statement/';
const CAL_TITLE = 'live call with kristen hinman';
const CAL_LOCATION = 'zoom link in your email';

const readSignup = () => {
  try { return JSON.parse(sessionStorage.getItem(BUILT_STORAGE_KEY) || 'null'); } catch (e) { return null; }
};

const toCalStamp = (d) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');

const googleUrl = (start, end) => {
  const p = new URLSearchParams({
    action: 'TEMPLATE', text: CAL_TITLE, dates: `${toCalStamp(start)}/${toCalStamp(end)}`, location: CAL_LOCATION,
  });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
};

const downloadIcs = (start, end) => {
  const ics = [
    'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//kristenhinman//built//EN', 'BEGIN:VEVENT',
    `UID:built-${toCalStamp(start)}@kristenhinman.com`, `DTSTAMP:${toCalStamp(new Date())}`,
    `DTSTART:${toCalStamp(start)}`, `DTEND:${toCalStamp(end)}`,
    `SUMMARY:${CAL_TITLE}`, `LOCATION:${CAL_LOCATION}`, 'END:VEVENT', 'END:VCALENDAR',
  ].join('\r\n');
  const url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = 'live-call-kristen-hinman.ics';
  a.click();
  URL.revokeObjectURL(url);
};

const AddToCalendar = ({ session }) => {
  const [open, setOpen] = useState(false);
  const start = new Date(session.start);
  const end = new Date(start.getTime() + SESSION_MINUTES * 60000);
  return (
    <div className="op-cal">
      <button type="button" className="op-btn op-btn-ink" onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid="op-add-calendar">
        add to calendar
      </button>
      {open && (
        <div className="op-cal-menu" data-testid="op-cal-menu">
          <a href={googleUrl(start, end)} target="_blank" rel="noopener noreferrer" className="op-btn op-btn-line" data-testid="op-cal-google">google</a>
          <button type="button" className="op-btn op-btn-line" onClick={() => downloadIcs(start, end)} data-testid="op-cal-ics">apple / .ics</button>
        </div>
      )}
    </div>
  );
};

const YoureIn = ({ signup }) => {
  const name = signup?.first_name;
  const session = signup?.session;
  return (
    <section className="op-sec op-hero" data-testid="op-youre-in">
      <h1 className="op-h1" data-testid="op-heading">{name ? <>you&apos;re in, {name}.</> : <>you&apos;re in.</>}</h1>
      {session && (
        <>
          <p className="op-lead" data-testid="op-time-line">
            i&apos;ll see you {session.label.replace(/\s*pacific\s*$/i, '')} pacific for our 30 minutes. the zoom link is on its way to your email.
          </p>
          <AddToCalendar session={session} />
        </>
      )}
      {signup && !session && (
        <p className="op-lead" data-testid="op-recording-line">i&apos;ll personally make sure you get the recording.</p>
      )}
    </section>
  );
};

const QuizSection = ({ signup }) => (
  <section className="op-sec" data-testid="op-quiz">
    <h2 className="op-h2">one thing before we go live</h2>
    <p className="op-p">take my 8-question quiz, because it gives you my honest take on whether this makes sense for you, and i&apos;ll read your answers before the call so i know who&apos;s coming.</p>
    <BuiltQuiz signup={signup} />
  </section>
);

const WALK = [
  "why every way you've been told to make more costs you more of your time.",
  "what you've already built that you're not getting paid for yet (hint: it's the people who already trust you).",
  "how this actually works, including the question i get the most: how much can you actually make selling shampoo? (yes, it's shampoo. we're going there.)",
  "how to tell if it'd even be a fit for you, because it isn't for everyone & i'd rather you know.",
];

const ABOUT = [
  "i've spent almost 20 years working with doctors & experts. i used to book celebrity doctors on TV at a PR firm, then i started a digital agency, then my own coaching & consulting practice. and in over a decade of having my own business, the only time i got paid was when i was actively working.",
  "i said no to network marketing every single time. i was the biggest skeptic. then a friend who'd sold her agency told me her next seven figure business was going to be selling shampoo, so i asked every hard question i could think of, and every question just became more of a yes.",
  "and then life was lifing. we were in a pressure cooker all summer, and in august, right before the kids went back to school, i realized i'd been getting paid every week for relationships i already had. that was an entirely new experience for me.",
];

const FAQ = [
  ['do i need my own business?', 'no. you need people who already trust you, and you already have those.'],
  ['is this network marketing?', "yes, it's direct sales, & i'm telling you up front because i'd want to know. there are no quotas, no monthly fees & no inventory sitting in your space."],
  ['do i have to give up what i do now?', 'no. you keep your clients or your job. it gets to be both and.'],
  ['are you going to sell me something?', "at the end i'll show you what starting looks like, & you get to decide. a no is completely fine."],
  ['what does it cost?', "the call is free. if you decide to start with the products, a starting cart is usually $110 to $150. if you want to do what i do, it's about $300 for your products & your storefront, with 90 days of coaching with me & no separate coaching fee."],
];

const Faq = () => (
  <section className="op-sec" data-testid="op-faq">
    <h2 className="op-h2">what people ask me first</h2>
    <dl className="op-faq">
      {FAQ.map(([q, a]) => (
        <div key={q} className="op-faq-item"><dt>{q}</dt><dd>{a}</dd></div>
      ))}
      <div className="op-faq-item">
        <dt>how much can i make?</dt>
        <dd>
          it depends on so many things, so i won&apos;t throw numbers around on a page. monat publishes its real averages in the{' '}
          <a href={IDS_URL} target="_blank" rel="noopener noreferrer" className="op-link" data-testid="op-faq-ids-link">income disclosure statement</a>
          , and i&apos;ll walk you through it live.
        </dd>
      </div>
    </dl>
  </section>
);

export default function Opportunity() {
  const [signup] = useState(readSignup);

  useEffect(() => {
    document.title = "you're in · kristen hinman";
    axios.post(`${API}/built/view`, { page: 'opportunity' }).catch(() => {});
  }, []);

  return (
    <div className="op-page" data-testid="opportunity-page">
      <main className="op-wrap">
        <YoureIn signup={signup} />
        <QuizSection signup={signup} />
        <section className="op-sec" data-testid="op-walk">
          <h2 className="op-h2">what i&apos;ll walk you through</h2>
          <ul className="op-list">{WALK.map((t) => <li key={t}>{t}</li>)}</ul>
        </section>
        {SHOW_BONUS_BAND && (
          <section className="op-bonus" data-testid="op-bonus-band">
            my company has a november + december bonus of up to $1,500. requirements apply, &amp; i&apos;ll walk you through them live.
          </section>
        )}
        <section className="op-sec" data-testid="op-about">
          <div className="op-about">
            <img src={ME} alt="kristen hinman in a sunroom" className="op-about-photo" data-testid="op-about-photo" />
            <div className="op-about-text">
              <h2 className="op-h2">hi, i&apos;m kristen</h2>
              {ABOUT.map((t) => <p key={t} className="op-p">{t}</p>)}
            </div>
          </div>
        </section>
        <Faq />
        <section className="op-sec op-close" data-testid="op-close">
          <a href="/run-it" target="_blank" rel="noopener noreferrer" className="op-btn op-btn-outline" data-testid="op-runit-button">
            don&apos;t want to wait for the call? see how it works →
          </a>
        </section>
        <footer className="op-footer" data-testid="op-footer">
          kristen hinman is an independent monat market partner. earnings are not guaranteed &amp; individual results vary. income disclosure statement:{' '}
          <a href={IDS_URL} target="_blank" rel="noopener noreferrer" className="op-link" data-testid="op-footer-ids-link">monatglobal.com/income-disclosure-statement</a>
        </footer>
      </main>
    </div>
  );
}
